import { Component, input, model } from '@angular/core'

import { PanelSize } from '@flowx/designer/modules/process-details/process-details-helper.service'
import { ExpandablePanelComponent } from '@flowx/designer/shared/components/bottom-panel/expandable-panel/expandable-panel.component'
import { ProcessInstance } from '@flowx/designer/shared/entities/process-instance.types'
import { UiFlowSession } from '@flowx/designer/shared/entities/ui-flow-sessions.types'

import { UiFlowSessionDetailsPanelHeaderComponent } from '../ui-flow-session-details-panel-header/ui-flow-session-details-panel-header.component'
import { UiFlowSessionTabsComponent } from '../ui-flow-session-tabs/ui-flow-session-tabs.component'

@Component({
  selector: 'flx-ui-flow-session-details-panel',
  imports: [
    ExpandablePanelComponent,
    UiFlowSessionDetailsPanelHeaderComponent,
    UiFlowSessionTabsComponent,
  ],
  templateUrl: './ui-flow-session-details-panel.component.html',
})
export class UiFlowSessionDetailsPanelComponent {
  size = model<PanelSize>(PanelSize.MEDIUM)
  uiFlowSession = input.required<UiFlowSession>()
  processInstances = input.required<ProcessInstance[]>()
}
